import SignalTable from 'components/global/SignalTable/SignalTable';
import { $list, $view } from 'signals/global.signals';
import useEffectAsync from 'utils/useEffectAsync';
import SimpleCard from 'components/global/SimpleCard';
import { handleClickEditPerson } from 'components/views/FounderTeam/_helpers/founderTeam.events';
import FounderEditPersonModal from './FounderEditPersonModal';
import FounderPersonDeleteModal from './FounderPersonDeleteModal';
import FounderPersonRows from './FounderPersonRows';
import { fetchAndSetOrganizationUsers } from '../_helpers/founderTeam.resolvers';

const InvestorPeople = () => {
  useEffectAsync(fetchAndSetOrganizationUsers);
  return (
    <>
      <SimpleCard>
        <SignalTable
          headers={[{
            key: 'name',
            value: 'Name',
          }, {
            key: 'email',
            value: 'Email',
          }, {
            key: 'Roles',
            value: 'Roles',
          }, {
            key: 'Actions',
            value: 'Actions',
          }]}
          rows={FounderPersonRows({ data: $list.value.data || [] })}
          isLoading={$view.value.isTableLoading}
          onRowClick={(row) => handleClickEditPerson(row)}
        />
      </SimpleCard>
      <FounderEditPersonModal />
      <FounderPersonDeleteModal />
    </>
  );
};

export default InvestorPeople;
